import { configApiRef } from '@backstage/core-plugin-api';
import { Header } from '@backstage/core-components';
import { Incident } from '../types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { useApi } from '@backstage/core-plugin-api';
import { useStyles } from './incidentCard.style';

import {
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Divider,
  Typography,
} from '@material-ui/core';
import { ExternalLink, normalizeStringLength } from '@internal/ui-common';

type IncidentCardProps = {
  incident: Incident;
};

const IncidentCard = ({ incident }: IncidentCardProps) => {
  const { cx, classes } = useStyles();
  const config = useApi(configApiRef);
  const healthpageBaseUrl = config.getString('app.healthpage.baseUrl');

  const handleCardClick = (event: React.MouseEvent) => {
    if ((event.target as HTMLElement).tagName !== 'A') {
      // make sure that the right link is followed when clicking (the service links vs the full card link)
      window.open(healthpageBaseUrl, '_blank');
    }
  };

  return (
    <Card className={cx(classes.incidentCard)}>
      <CardActionArea onClick={handleCardClick}>
        <div className={cx(classes.header)}>
          <Header title={undefined}>
            <Typography variant="subtitle1">
              {normalizeStringLength(incident.title, 21)}
            </Typography>
            {incident.priority && (
              <Chip label={incident.priority} className={cx(classes.chip)} />
            )}
          </Header>
        </div>

        <CardContent className={cx(classes.content)}>
          <Typography variant="body2">
            {incident.description ? incident.description : 'No description'}
          </Typography>
        </CardContent>

        <Divider />

        <CardContent className={cx(classes.content)}>
          <Typography variant="body2" className={classes.impactedServices}>
            Impacted services
          </Typography>
          {incident.impactedServices && incident.impactedServices.length > 0 ? (
            <List>
              {incident.impactedServices.map(service => (
                <ListItem key={service.serviceId} dense>
                  <ExternalLink
                    to={`${healthpageBaseUrl}/service/${service.serviceId}`}
                  >
                    - {normalizeStringLength(service.serviceName, 24)}
                  </ExternalLink>
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body2">No impacted services</Typography>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export { IncidentCard };
